document.querySelectorAll('.cards').forEach((scrollContainer) => {
  const scrollButtons = document.querySelector('.scroll-buttons')
  const btnLeft = scrollButtons.querySelector('.btn-left')
  const btnRight = scrollButtons.querySelector('.btn-right')

  const startMarker = scrollContainer.querySelector('.spacer-item')
  const endMarker = scrollContainer.querySelector('.last-item')

  // IntersectionObserver Optionen
  const observerOptions = {
    root: scrollContainer,
    threshold: 0.99,
    rootMargin: `0px ${parseInt(getComputedStyle(scrollContainer).gap) || 0}px`,
  }

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.target === startMarker) {
        btnLeft.disabled = entry.isIntersecting
      } else if (entry.target === endMarker) {
        btnRight.disabled = entry.isIntersecting
      }
    })
  }

  const observer = new IntersectionObserver(observerCallback, observerOptions)

  observer.observe(startMarker)
  observer.observe(endMarker)

  // Drag-and-Drop Funktionalität
  let isDragging = false
  let startX, startScrollLeft
  const dragThreshold = 5

  function getMousePosition(e) {
    return e.clientX - scrollContainer.getBoundingClientRect().left
  }

  function startDragging(e) {
    isDragging = true
    scrollContainer.classList.add('active')
    startX = getMousePosition(e)
    startScrollLeft = scrollContainer.scrollLeft
    scrollContainer.style.cursor = 'grabbing'
    scrollContainer.style.userSelect = 'none'

    document.addEventListener('mousemove', drag, { passive: false })
    document.addEventListener('mouseup', stopDragging)

    e.preventDefault()
  }

  function drag(e) {
    if (!isDragging) return
    e.preventDefault()

    const x = getMousePosition(e)
    const walk = (x - startX) * 1.5

    requestAnimationFrame(() => {
      scrollContainer.scrollLeft = startScrollLeft - walk
    })
  }

  function stopDragging() {
    isDragging = false
    scrollContainer.classList.remove('active')
    scrollContainer.style.cursor = 'grab'
    scrollContainer.style.removeProperty('user-select')
    document.removeEventListener('mousemove', drag)
    document.removeEventListener('mouseup', stopDragging)
  }

  scrollContainer.addEventListener('mousedown', startDragging)

  scrollContainer.addEventListener('click', (e) => {
    if (Math.abs(scrollContainer.scrollLeft - startScrollLeft) > dragThreshold) {
      e.preventDefault()
    }
  })

  // Button-Funktionalität
  let scrollInterval
  const scrollStep = 15
  const scrollDelay = 10

  function startContinuousScroll(direction) {
    stopContinuousScroll()
    function step() {
      scrollContainer.scrollLeft += direction * scrollStep
      scrollInterval = requestAnimationFrame(step)
    }
    scrollInterval = requestAnimationFrame(step)
  }

  function stopContinuousScroll() {
    if (scrollInterval) {
      cancelAnimationFrame(scrollInterval)
      scrollInterval = null
    }
  }

  function handleButtonInteraction(button, direction) {
    let pressTimer
    let isLongPress = false

    function singleScroll() {
      scrollContainer.scrollBy({ left: direction * scrollContainer.clientWidth, behavior: 'smooth' })
    }

    function handleButtonPress(e) {
      // Prevent default behavior for all button interactions
      e.preventDefault()

      if (button.disabled) return

      isLongPress = false

      pressTimer = setTimeout(() => {
        isLongPress = true
        startContinuousScroll(direction)
      }, 500)
    }

    function handleButtonRelease(e) {
      // Prevent default behavior for button release
      e.preventDefault()

      clearTimeout(pressTimer)
      if (!isLongPress) {
        singleScroll()
      }
      stopContinuousScroll()
    }

    // Maus-Events mit preventDefault
    button.addEventListener('mousedown', handleButtonPress)
    button.addEventListener('mouseup', handleButtonRelease)
    button.addEventListener('mouseleave', (e) => {
      e.preventDefault()
      clearTimeout(pressTimer)
      stopContinuousScroll()
    })

    // Tastatur-Events
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        handleButtonPress(e)
      }
    })

    button.addEventListener('keyup', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        handleButtonRelease(e)
      }
    })
  }

  handleButtonInteraction(btnLeft, -1)
  handleButtonInteraction(btnRight, 1)

  // Funktion zum Überprüfen der Scroll-Position
  function checkScrollPosition() {
    const scrollLeftPos = scrollContainer.scrollLeft
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth

    btnLeft.disabled = scrollLeftPos <= 1
    btnRight.disabled = scrollLeftPos >= maxScrollLeft - 5
  }

  scrollContainer.addEventListener('scroll', checkScrollPosition, { passive: true })

  // Initiale Überprüfung der Buttonzustände
  checkScrollPosition()
})
